import { Routes } from '@angular/router';
import { AsahiSuccessPageComponent } from './components/asahi/asahi-success-page/asahi-success-page.component';
import { MobileBannerAsahiComponent } from './components/asahi/mobile-banner-asahi/mobile-banner-asahi.component';
import { MobileSuccessPageComponent } from './components/asahi/mobile-success-page/mobile-success-page.component';
import { MobileFormAsahiComponent } from './components/asahi/mobile-form-asahi/mobile-form-asahi.component';
import { AsahiHomeComponent } from './components/asahi/asahi-home/asahi-home.component';
import { AsahiPremiumCalDetailsComponent } from './components/asahi/asahi-premium-cal-details/asahi-premium-cal-details.component';
import { MobilePremiumCalComponent } from './components/asahi/mobile-premium-cal/mobile-premium-cal.component';
import { MobilePremiumCalDetailsComponent } from './components/asahi/mobile-premium-cal-details/mobile-premium-cal-details.component';
import { MobilePremiumFormComponent } from './components/asahi/mobile-premium-form/mobile-premium-form.component';
export const AsahiRoutes: Routes = [
  {
    path: '',
    component: AsahiHomeComponent,
    children: [
        {
          path:'success-page',
          component:AsahiSuccessPageComponent
        },
        {
        path: 'explore',
        component: MobileBannerAsahiComponent,
      },
      {
            path: 'mobile',
            component: MobileFormAsahiComponent
      },
      {
          path:"mobile-success-page",
          component:MobileSuccessPageComponent
      },
      {
          path:'details',
          component:AsahiPremiumCalDetailsComponent
      },
      {
          path:'mobile-premium',
          component:MobilePremiumCalComponent
      },
      {
          path:'mobile-premium-form',
          component:MobilePremiumFormComponent
      },
            {
          path:'mobile-premium-details',
          component:MobilePremiumCalDetailsComponent
      }
    ]
  }
];
